import AuthorImg1 from "../assets/images/authorImg1.png";
import PublishingImg1 from "../assets/images/publishingImg1.png";
import PublishingImg2 from "../assets/images/publishingImg2.png";
import PublishingImg3 from "../assets/images/publishingImg3.png";
import OutcomeImg1 from "../assets/images/outcomeIcon1.svg";
import OutcomeImg2 from "../assets/images/outcomeIcon2.svg";
import OutcomeImg3 from "../assets/images/outcomeIcon3.svg";
import AppointmentImg1 from "../assets/images/appointmentImg1.png";
import AppointmentImg2 from "../assets/images/appointmentImg2.png";
import AppointmentImg3 from "../assets/images/appointmentImg3.png";
import AppointmentImg4 from "../assets/images/appointmentImg4.png";
import QuickDiscoveryImg1 from "../assets/images/QuickDiscoveryImg1.png";
import QuickDiscoveryImg2 from "../assets/images/QuickDiscoveryImg2.png";
import QuickDiscoveryImg3 from "../assets/images/QuickDiscoveryImg3.png";
import PartnersImg1 from "../assets/images/partnersImg1.png";
import PartnersImg2 from "../assets/images/partnersImg2.png";
import AuthorImg2 from "../assets/images/authorImg2.png";
import InstituteBtmImg1 from "../assets/images/insituteBtmImg1.svg";
import InstituteBtmImg2 from "../assets/images/insituteBtmImg2.svg";
import InstituteBtmImg3 from "../assets/images/insituteBtmImg3.svg";
import InstituteBtmImg4 from "../assets/images/insituteBtmImg4.svg";

export const testimonials = [
  {
    id: 6,
    label: "Dr. Gianluca Esposito, Neuroscientist, NTU",
    designation: "",
    image: "1749627753_GE.jpg",
    rating: null,
    description:
      "Thank you for the excellent and courteous technical support, prompt responses, and on-site assistance when needed.",
    button_name: null,
    status: 1,
    deleted_at: null,
    created_at: "2025-06-11T07:42:33.000000Z",
    updated_at: "2025-06-13T06:30:40.000000Z",
  },
  {
    id: 1,
    label: "Dr. Aditi Verma",
    designation: "Professor, University of Delhi",
    description:
      "IMPAC provided me with excellent mentorship opportunities and helped me collaborate with international researchers.",
    image: AuthorImg1,
    button_name: "Published via Knowledge Series",
  },
  {
    id: 2,
    label: "Dr. John Smith",
    designation: "Author & Researcher",
    description:
      "Through IMPAC, I was able to publish my work in reputed journals with ease and guidance.",
    image: AuthorImg1,
    button_name: "Published via Knowledge Series",
  },
  {
    id: 3,
    label: "Dr. Maria Garcia",
    designation: "Mentor, Stanford",
    description:
      "This platform bridges the gap between institutions and researchers worldwide. Truly impactful!",
    image: AuthorImg1,
    button_name: "Published via Knowledge Series",
  },
  {
    id: 4,
    label: "Dr. Harish Dubey",
    designation: "Researcher",
    description:
      "The networking and collaboration opportunities here are incredible. Highly recommend IMPAC!",
    image: AuthorImg1,
    button_name: "Published via Knowledge Series",
  },
];

export const PublishingData = [
  {
    id: 7,
    title: "Publishing Outcome Information 1",
    heading: "Text 1",
    button_name: "Text 1",
    image: "1758268501_133844266586745395.jpg",
    link: "http://imparc.devs/admin/quick-discovery/create",
    datetime: "2025-09-18 16:30:00",
    status: 1,
    deleted_at: null,
    created_at: "2025-09-19T07:48:19.000000Z",
    updated_at: "2025-09-19T07:55:01.000000Z",
  },
  {
    id: 1,
    image: PublishingImg1,
    title: "Next Event",
    heading: "Global Knowledge Summit 2025",
    datetime: "March 15, 2025 | 10:00 AM EST",
    button_name: "Register Now",
  },
  {
    id: 2,
    image: PublishingImg2,
    title: "Calls for Papers",
    heading: "Digital Transformation",
    datetime: "March 15, 2025 | 10:00 AM EST",
    button_name: "Submit Chapter",
  },
  {
    id: 3,
    image: PublishingImg3,
    title: "Post-Event Toolkits",
    heading: "Research Methodology Guide",
    datetime: "",
    button_name: "Download PDF",
  },
];

export const PartnerProgramData = [
  {
    id: 1,
    title: "IMPARC Knowledge Partner",
    short_desc:
      "For NAAC A++ colleges: 3-4 events per year, regional collaboration, co-branding opportunities, and partner recognition. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    tags: ["Regional Focus", "Recognition", "Co-branding"],
    button_name: "Become a Partner",
    link: "http://imparc.devs/admin/quick-discovery/create",
    status: 1,
    order: 0,
  },
  {
    id: 2,
    title: "IMPARC Knowledge Partner",
    short_desc:
      "For NAAC A++ colleges: 3-4 events per year, regional collaboration, co-branding opportunities, and partner recognition. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
    tags: ["Regional Focus", "Recognition", "Co-branding"],
    button_name: "Become a Partner",
  },
  {
    id: 3,
    title: "IMPARC Knowledge Hub",
    short_desc:
      "For NAAC A++ universities: national training programs, guest editing opportunities.",
    tags: ["Regional Focus", "Recognition", "Co-branding"],
    button_name: "Become a Hub",
  },
  {
    id: 4,
    title: "Center of Academic Collaboration (CAC)",
    short_desc:
      "For NAAC A++ colleges: 3-4 events per year, regional collaboration, co-branding opportunities, and partner recognition.",
    tags: ["Regional Focus", "Recognition", "Co-branding"],
    button_name: "Become a Hub",
  },
];

export const OutcomeData = [
  {
    id: 7,
    title: "Publishing Outcome Information 1",
    text: "Text",
    image: null,
    number: "15",
    number_text: "Number Text",
    status: 1,
    deleted_at: null,
    created_at: "2025-09-19T08:11:50.000000Z",
    updated_at: "2025-09-19T08:11:50.000000Z",
  },
  {
    id: 1,
    image: OutcomeImg1,
    number: 127,
    number_text: "Journal",
    title: "Journal Publications",
    text: "+12%vs last year",
  },
  {
    id: 2,
    image: OutcomeImg2,
    number: 43,
    number_text: "ISBN",
    title: "Published Books",
    text: "+12%vs last year",
  },
  {
    id: 3,
    image: OutcomeImg3,
    number: 89,
    number_text: "DOI",
    title: "DOI Papers",
    text: "+12%vs last year",
  },
];

export const MentorsData = [
  {
    id: 4,
    title: "Dr. Lisa Thompson",
    designation: "Behavioral Economics",
    feedback:
      "IMPAC provided me with excellent mentorship opportunities and helped me collaborate with international researchers.",
    image: AuthorImg1,
    expertise: "abc",
    response_time: "12",
    success_rate: "10",
  },
  {
    id: 3,
    title: "Dr. Lisa Thompson",
    designation: "Behavioral Economics",
    feedback:
      "IMPAC provided me with excellent mentorship opportunities and helped me collaborate with international researchers.",
    image: AuthorImg1,
    expertise: "",
    response_time: "",
    success_rate: "",
  },
  {
    id: 2,
    title: "Dr. Lisa Thompson",
    designation: "Behavioral Economics",
    feedback:
      "IMPAC provided me with excellent mentorship opportunities and helped me collaborate with international researchers.",
    image: AuthorImg1,
    expertise: "",
    response_time: "",
    success_rate: "",
  },
  {
    id: 1,
    title: "Mentor Information1",
    image: "1757874936_133849349034964184.jpg",
    designation: "Sr. PHP Developer",
    expertise: "LARAVEL, PHP",
    response_time: "8AM  to 8PM",
    status: 1,
    success_rate: "10",
    deleted_at: null,
    created_at: "2025-09-14T18:35:36.000000Z",
    updated_at: "2025-09-14T18:41:42.000000Z",
  },
];

export const KnowledgeSeriesData = [
  {
    id: 2,
    date_range: "Mar 15-17",
    title: "Research Methods Workshop",
    button_name: "Proceedings ISBN",
    link: "/",
  },
  {
    id: 3,
    date_range: "Jun 20-22",
    title: "AI in Education Conference",
    button_name: "Special Issue",
    link: "/",
  },
  {
    id: 4,
    date_range: "Sat 10-12",
    title: "Data Analytics FDP",
    button_name: "Toolkit",
    link: "/",
  },
  {
    id: 5,
    date_range: "Dec 5-7",
    title: "AI in Education Conference",
    button_name: "Planning",
    link: "/",
  },
  {
    id: 1,
    date_range: "1 SEP to 30 SEP 2025",
    title: "Knowledge Series",
    button_name: "Button Name",
    link: "http://imparc.devs/admin/quick-discovery/create",
    short_desc: null,
    status: 1,
    order: 0,
    deleted_at: null,
    created_at: "2025-09-13T19:47:44.000000Z",
    updated_at: "2025-09-13T19:51:32.000000Z",
  },
];

export const counterData = {
  "Special Issues": "8+",
  "Edited Books": "5",
  Proceessdings: 2,
  Digests: "12",
  "DOI Papers": 60,
};

export const AppointmentData = [
  {
    id: 6,
    title: "Dr. Gianluca Esposito, Neuroscientist, NTU",
    short_desc: "",
    image: "1749627753_GE.jpg",
    status: 1,
    deleted_at: null,
    created_at: "2025-06-11T07:42:33.000000Z",
    updated_at: "2025-06-13T06:30:40.000000Z",
  },
  {
    id: 1,
    image: AppointmentImg1,
    title: "Governing Academic Council",
    short_desc: "Strategic oversight & academic excellence standards",
  },
  {
    id: 2,
    image: AppointmentImg2,
    title: "Mentorship & Research Guidance",
    short_desc: "Strategic oversight & academic excellence standards",
  },
  {
    id: 3,
    image: AppointmentImg3,
    title: "Knowledge Series Executive",
    short_desc: "Curating and managing knowledge series content",
  },
  {
    id: 4,
    image: AppointmentImg4,
    title: "Editorial & Publishing Board",
    short_desc: "Strategic oversight & academic excellence standards",
  },
];

export const loginData = {
  message: "Login successful",
  user: {
    id: 6,
    name: "Dhruv Shakywar",
    email: "dhruv@iflextech.in",
    email_verified_at: null,
    cpassword: "123456",
    created_at: "2025-09-09T04:34:17.000000Z",
    updated_at: "2025-09-09T04:34:17.000000Z",
    role_id: "2",
    status: 0,
    deleted_at: null,
    image: "1757392456_impark.png",
  },
  token: "3|grOhMTOLnnZFRwKEQMs8di3xFN5ljCClEydgUxHE046897b1",
};

export const QuickDiscoveryData = [
  {
    id: 6,
    image: "1757791910_133849349034964184.jpg",
    title: "Find an Expert Mentor",
    button_name: "Button Name Here",
    link: "http://imparc.devs/admin/quick-discovery/create",
    short_desc:
      "Browse profiles with domain exttpertise, methodology skills, &amp; turnaround times.",
    status: 1,
    order: 0,
    deleted_at: null,
    created_at: "2025-09-13T19:31:50.000000Z",
    updated_at: "2025-09-13T19:31:50.000000Z",
  },
  {
    id: 1,
    image: QuickDiscoveryImg1,
    title: "Find an Expert Mentor",
    short_desc:
      "Browse profiles with domain exttpertise, methodology skills, &amp; turnaround times.",
    button_name: "Buttton Name Here",
    link: "/mentors",
  },
  {
    id: 2,
    image: QuickDiscoveryImg2,
    title: "Explore Author Members",
    short_desc:
      "Browse profiles with domain exttpertise, methodology skills, &amp; turnaround times.",
    button_name: "Buttton Name Here",
    link: "/authors",
  },
  {
    id: 3,
    image: QuickDiscoveryImg3,
    title: "Institutional Members",
    short_desc:
      "Browse profiles with domain exttpertise, methodology skills, &amp; turnaround times.",
    button_name: "Buttton Name Here",
    link: "/institutions",
  },
];

export const AuthorSpotlightData = [
  {
    id: 1,
    title: "Author Member Information",
    designation: "Sr. PHP Developer",
    image: "1757917738_133849349034964184.jpg",
    tags: null,
    heading1: "Heading 1",
    heading2: "Heading 2",
    status: 1,
    deleted_at: null,
    created_at: "2025-09-15T06:28:58.000000Z",
    updated_at: "2025-09-15T08:09:13.000000Z",
  },
  {
    id: 4,
    heading1: "Dr. Lisa Thompson",
    heading2: "Behavioral Economics",
    tags: ["ORCID", "Scopus", "Google Scholar"],
    title: "Consumer Decision Making in Digital Markets",
    designation: "Journal of Economic Psychology, 2025",
    image: AuthorImg1,
  },
  {
    id: 2,
    heading1: "Dr. Lisa Thompson",
    heading2: "Behavioral Economics",
    tags: ["ORCID", "Scopus", "Google Scholar"],
    title: "Consumer Decision Making in Digital Markets",
    designation: "Journal of Economic Psychology, 2025",
    image: AuthorImg1,
  },
  {
    id: 3,
    heading1: "Dr. Lisa Thompson",
    heading2: "Behavioral Economics",
    tags: ["ORCID", "Scopus", "Google Scholar"],
    title: "Consumer Decision Making in Digital Markets",
    designation: "Journal of Economic Psychology, 2025",
    image: AuthorImg1,
  },
];

export const PartnerData = [
  {
    id: 1,
    title: "TTTTTTTTTTTT",
    roles: "RRRRRRRRRRRRR",
    image: "1757924053_133885904705861210.jpg",
    events: "30",
    publications: "40",
    status: 1,
    deleted_at: null,
    created_at: "2025-09-15T08:14:13.000000Z",
    updated_at: "2025-09-15T08:14:13.000000Z",
  },
  {
    id: 2,
    image: PartnersImg1,
    title: "Stanford Research Institute",
    roles: "Lead Partner",
    events: 12,
    publications: 45,
  },
  {
    id: 3,
    image: PartnersImg2,
    title: "CAC",
    roles: "Lead Partner",
    events: 12,
    publications: 45,
  },
];

export const subjectMatterExpertise = {
  1: [
    {
      id: 1,
      children: [
        {
          id: 3,
          children: [],
        },
      ],
    },
    {
      id: 4,
      children: [
        {
          id: 5,
          children: [],
        },
        {
          id: 6,
          children: [],
        },
        {
          id: 7,
          children: [],
        },
        {
          id: 8,
          children: [],
        },
        {
          id: 9,
          children: [],
        },
        {
          id: 10,
          children: [],
        },
        {
          id: 11,
          children: [],
        },
      ],
    },
    {
      id: 12,
      children: [
        {
          id: 13,
          children: [],
        },
        {
          id: 14,
          children: [],
        },
      ],
    },
    {
      id: 18,
      children: [
        {
          id: 19,
          children: [],
        },
      ],
    },
  ],
  2: [
    {
      id: 21,
      children: [
        {
          id: 22,
          children: [],
        },
        {
          id: 23,
          children: [],
        },
        {
          id: 24,
          children: [],
        },
      ],
    },
    {
      id: 30,
      children: [
        {
          id: 31,
          children: [
            {
              id: 32,
              children: [],
            },
            {
              id: 33,
              children: [],
            },
          ],
        },
        {
          id: 37,
          children: [
            {
              id: 38,
              children: [],
            },
            {
              id: 39,
              children: [
                {
                  id: 40,
                  children: [],
                },
              ],
            },
            {
              id: 44,
              children: [],
            },
            {
              id: 45,
              children: [
                {
                  id: 46,
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const mentorshipOffered = {
  1: [
    {
      id: 2,
      children: [],
    },
    {
      id: 6,
      children: [],
    },
  ],
  2: [
    {
      id: 3,
      children: [],
    },
    {
      id: 5,
      children: [],
    },
  ],
};

export const profileData = {
  id: "5",
  badge: "Highly Rated Expert",
  location: "Indian",
  rate: 120,
  description: `(Dr.) Prakash Divakaran is a distinguished academic leader, Vice Chancellor, and supply chain & operations expert with over 30 years of experience spanning academia, research, and corporate industry. He currently serves as the Vice Chancellor of Himalayan University, Itanagar, and CEO of Infinite Global Research Conference Pvt. Ltd. His professional background bridges senior academic roles—such as Vice Chancellor, Pro Vice Chancellor, and Director—with leadership positions in reputed organizations including Minda Industries, Polyrub Extrusions, and TI Cycles of India.
  \n Dr. Divakaran holds a Ph.D. in Management and several advanced degrees in International Business, Human Resources, Operations, and Supply Chain Management. He has mentored more than 14 Ph.D. scholars and has published over 120 research papers in UGC-listed and Scopus-indexed journals. Recognized internationally, he has chaired and organized over 50 academic events across Asia, the Middle East, and the US. His expertise encompasses academic governance, research management, accreditation, and the integration of AI, blockchain, and sustainability into management education. Dr. Divakaran is also a prolific author, having published multiple books and led initiatives in curriculum development, quality assurance, and global academic collaboration. His commitment to academic excellence is reflected in numerous awards for entrepreneurship, research, and educational leadership.`,
  rating: 4,
  image: AuthorImg2,
  name: "Dr. Ram Kumar",
  title: "Vice Chancellor | Supply Chain & Operations Expert",
  expertise: [
    "Supply Chain Management",
    "Operations Management",
    "Research",
    "Sustainability",
  ],
  services: ["Consulting", "Product Development", "Research"],
  experience: [
    {
      company: "Vinayaka Missions University",
      role: "Vice Chancellor",
      duration: "Jan 2023 – Present",
      description: "Leading faculty growth...",
    },
    {
      company: "Global Research Conference",
      role: "CEO",
      duration: "2021 – Present",
      description: "Organizing research events...",
    },
  ],
  education: [
    {
      institution: "Vinayaka Missions University",
      degree: "PhD in Business",
      year: "2010",
    },
    {
      institution: "IGNOU",
      degree: "MBA Supply Chain",
      year: "2005",
    },
  ],
  certifications: [
    {
      title: "Supply Chain Forecasting",
      issuer: "International Logistics Conference",
      year: "2019",
    },
  ],
  publications: [
    {
      title: "Research Methodologies",
      journal: "Journal of Modern Business",
      year: "2021",
    },
  ],
  tags: [
    "Business",
    "Engineering",
    "Economics",
    "Technology, & Data",
    "Economics",
    "Technology, & Data",
    "Business",
    "Engineering",
    "Economics",
    "Technology, & Data",
    "Economics",
    "Technology, & Data",
  ],
};

export const institiuteBtmData = [
  {
    id: 1,
    img: InstituteBtmImg1,
    title: "Top Ranking",
    description: "Consistently ranked among top 200 universities globally and #1 in India by NIRF",
  },
  {
    id: 2,
    img: InstituteBtmImg2,
    title: "Research Excellence",
    description: "Over 5,000 research papers published annually with high citation impact",
  },
  {
    id: 3,
    img: InstituteBtmImg3,
    title: "Industry Partnerships",
    description: "Strong collaboration with 200+ industry partners and Fortune 500 companies",
  },
  {
    id: 4,
    img: InstituteBtmImg4,
    title: "Innovation Hub",
    description: "50+ active startups incubated with combined valuation exceeding $500M",
  },
];
